<template>
  <calendar
    ref="tuiCalendar"
    style="height: 800px; outline: 1px solid lightgray"
    view="month"
    :usage-statistics="false"
    :is-read-only="true"
    :schedules="events"
    :calendars="calendars"
    :month="{ dayNames, startDayOfWeek: 1, }"
  />
</template>

<script>
import 'tui-calendar/dist/tui-calendar.css'
import Calendar from '@toast-ui/vue-calendar/src/Calendar.vue'
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'
import { mapGetters } from 'vuex'

export default {
  name: 'CalendarTuiWrapper',
  components: {
    Calendar
  },
  data () {
    return {
      dayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
    }
  },
  computed: {
    ...mapGetters('calendar', [
      'getAllEvents',
      'getMonth',
      'getYear',
      'getCalendars',
      'getView'
    ]),
    events () {
      const events = JSON.parse(JSON.stringify(this.getAllEvents))
      if (events === undefined) return []
      for (const event of events) {
        event.start = event.start + ' ' + event.start_time
        event.end = event.end + ' ' + event.end_time
        event.borderColor = 'white'
      }
      return events
    },
    month () {
      return this.getMonth
    },
    year () {
      return this.getYear
    },
    calendars () {
      return this.getCalendars
    },
    view () {
      return this.getView
    }
  },
  watch: {
    month () {
      this.setTuiDate()
    },
    year () {
      this.setTuiDate()
    },
    view () {
      this.setTuiDate()
    }
  },
  mounted () {
    this.setTuiDate()
  },
  methods: {
    setTuiDate () {
      this.$refs.tuiCalendar.invoke('setDate', Date.parse(`${this.getYear}-${this.getMonth}-01`))
      this.$refs.tuiCalendar.invoke('render')
    }
  }
}
</script>

<style scoped>

</style>
